import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { useGetClientThemeQuery } from "src/store/slices/client/client.api";
import { setClientTheme } from "src/store/slices/client/client.slice";
import { persistedTheme } from "src/store/persistedClientData";
import { applyThemeTokens } from "src/utility";


export default function useGetClientTheme({ skip = false }: { skip?: boolean } = {}) {
  const token = useSelector((state: RootState) => state.auth.token);
  const [cachedTheme] = useState(() => persistedTheme.read());
  const { data: theme, isFetching , error} = useGetClientThemeQuery(undefined, { skip: skip || !token || !!cachedTheme });
  const dispatch = useDispatch();
  useEffect(() => {
    if (cachedTheme) {
      applyThemeTokens(cachedTheme);
      return;
    }
    if (theme) {
      applyThemeTokens(theme);
      dispatch(setClientTheme(theme));
    }
  }, [theme]);
  return { isFetching, theme, error };
}
